/* Filters.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, xcss } from '@atlaskit/primitives';
import { Show } from '@atlaskit/primitives/responsive';
import React from 'react';
import { charlieTextFontFamily } from '../FontFamily';
import { DesktopFilters } from './DesktopFilters';
import { MobileFilters } from './MobileFilters';
const wrapperStyles = xcss(charlieTextFontFamily);
export const Filters = _ref => {
  let {
    filterOptions,
    filterDefinitions,
    filterStatus = {},
    selectedOptions = {},
    selectedSortOption,
    showAllFilters = false,
    sortOptions,
    onClearFilter,
    onClearAllFilters,
    onShowAllFilters,
    onSelectedOptionsChange,
    onSelectedSortOptionChange,
    onApplyFilters,
    onCloseMobileDialog
  } = _ref;
  if (!filterDefinitions.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: wrapperStyles
  }, /*#__PURE__*/React.createElement(Show, {
    below: "sm",
    as: "span"
  }, /*#__PURE__*/React.createElement(MobileFilters, {
    filterDefinitions: filterDefinitions,
    filterOptions: filterOptions,
    selectedOptions: selectedOptions,
    sortOptions: sortOptions,
    selectedSortOption: selectedSortOption,
    filterStatus: filterStatus,
    onClearAllFilters: onClearAllFilters,
    onSelectedOptionsChange: onSelectedOptionsChange,
    onSelectedSortOptionChange: onSelectedSortOptionChange,
    onApplyFilters: onApplyFilters,
    onCloseMobileDialog: onCloseMobileDialog
  })), /*#__PURE__*/React.createElement(Show, {
    above: "sm",
    as: "span"
  }, /*#__PURE__*/React.createElement(DesktopFilters, {
    filterDefinitions: filterDefinitions,
    filterOptions: filterOptions,
    filterStatus: filterStatus,
    selectedOptions: selectedOptions,
    onClearFilter: onClearFilter,
    onClearAllFilters: onClearAllFilters,
    onSelectedOptionsChange: onSelectedOptionsChange,
    showAllFilters: showAllFilters,
    onShowAllFilters: onShowAllFilters
  })));
};